import(/* webpackMode: "eager" */ "/home/oreetiene/test.adi-mag.ro/app/(otherPages)/politica-de-confidentialitate/page.jsx");
